import { render, staticRenderFns } from "./TxProductAdminPortal.vue?vue&type=template&id=a5b37252&scoped=true&"
import script from "./TxProductAdminPortal.vue?vue&type=script&lang=js&"
export * from "./TxProductAdminPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b37252",
  null
  
)

export default component.exports